export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    //redirectUri: "https://qaazr-dev-api-hubpedidos.qualtia.com/login_response",
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true,
  },
};



export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    process.env.REACT_APP_SCOPE
  ]};
/**
export const loginRequest = {
  scopes: ["User.Read","openid","api://09d4d7a2-3d34-495c-b14e-e29665645f48/api-hubpedidos-dev"] // ajusta según tus necesidades
};
*/